import React, { useEffect, useState } from 'react';
import { ownerApi } from '../../lib/ownerApi';
import { Search, ChevronRight } from 'lucide-react';
import { Link } from 'react-router-dom';

export default function OwnerPeoplePage() {
  const [search, setSearch] = useState('');
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    ownerApi.queryPeople(search)
      .then(d => { if (!cancelled) { setData(d); setLoading(false); } })
      .catch(() => { if (!cancelled) { setData({ items: [], total: 0 }); setLoading(false); } });
    return () => { cancelled = true; };
  }, [search]);

  return (
    <div className="space-y-4" data-testid="owner-people">
      <div className="flex items-center justify-between">
        <h2 className="text-xl font-semibold">People & Users</h2>
        <span className="text-xs text-stone-500" data-testid="owner-people-count">
          {loading ? '…' : `${data?.total ?? 0} persons`}
        </span>
      </div>

      <div className="relative">
        <Search className="w-4 h-4 absolute left-3 top-3 text-stone-400" />
        <input
          type="text"
          placeholder="Search by email, name, or person_id…"
          value={search}
          onChange={e => setSearch(e.target.value)}
          className="w-full pl-9 pr-3 h-10 rounded-2xl border border orka-border-subtle orka-surface-raised text-sm focus:outline-none focus:ring-2 focus:ring-violet-300"
          data-testid="owner-people-search"
        />
      </div>

      <div className="rounded-2xl border border orka-border-subtle orka-surface-raised overflow-hidden">
        <table className="w-full text-sm">
          <thead className="bg-stone-50 dark:bg-slate-800 text-[11px] uppercase tracking-wider text-stone-500">
            <tr>
              <th className="text-left px-4 py-2.5">Person</th>
              <th className="text-left px-3 py-2.5">Email</th>
              <th className="text-left px-3 py-2.5">Person ID</th>
              <th className="text-right px-4 py-2.5">Created</th>
              <th className="w-8"></th>
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr><td colSpan={5} className="text-center py-8 text-stone-400 text-xs">Loading…</td></tr>
            ) : (data?.items || []).length === 0 ? (
              <tr><td colSpan={5} className="text-center py-12 text-stone-400 text-xs italic">No persons found.</td></tr>
            ) : (data?.items || []).map(p => (
              <tr
                key={p.person_id}
                className="border-t border-stone-100 dark:border-slate-800 hover:bg-stone-50 dark:hover:bg-slate-800/50"
                data-testid={`owner-person-row-${p.person_id}`}
              >
                <td className="px-4 py-2.5">
                  <Link to={`/owner/people/${encodeURIComponent(p.person_id)}`} className="font-medium orka-text-primary hover:underline">
                    {p.display_name || '—'}
                  </Link>
                </td>
                <td className="px-3 py-2.5 text-xs orka-text-secondary">{p.primary_email || '—'}</td>
                <td className="px-3 py-2.5 text-[11px] font-mono text-stone-500 truncate max-w-[220px]">{p.person_id}</td>
                <td className="px-4 py-2.5 text-right text-[11px] font-mono text-stone-500">{(p.created_at || '').slice(0, 10)}</td>
                <td className="text-stone-400">
                  <Link to={`/owner/people/${encodeURIComponent(p.person_id)}`} className="block px-2 py-1">
                    <ChevronRight className="w-4 h-4" />
                  </Link>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
